// @flow
import React from 'react';
import {Route, Switch, Redirect, useLocation} from 'react-router-dom';
import {makeStyles} from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import {ThemeProvider} from '@material-ui/core/styles';

import {theme} from './theme';
import {useAppInitialization} from './hooks/use-app-initialization';

// Layouts
import AuthenticatedLayout from './layouts/authenticated-layout';
import UnauthenticatedLayout from './layouts/unauthenticated-layout';

// Public routes components
import AuthContainer from './modules/auth/containers/AuthContainer';
import OnBoardingTrialContainer from './modules/on-boarding/containers/OnBoardingTrialContainer';

// Private routes
import {AppRoutes} from './router/app-routes';
import {PrivateRoute} from './router/PrivateRoute';
import BottomNavbarContainer from './modules/bottomNavbar/containers/BottomNavbarContainer';
import {APP_BAR_HEIGHT} from './layouts/constants';
import OnboardingPage from './modules/on-boarding/components/OnboardingPage';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    height: `calc(100vh - ${APP_BAR_HEIGHT}px)`,
    width: '100vw',
    overflowX: 'hidden',
    background: '#F8F9FB',

    [theme.breakpoints.up('md')]: {
      height: '100vh',
    },
  },
  fullWidthContainer: {
    position: 'relative',
    width: '100%',
    background: '#F8F9FB',
  },
});

function App() {
  const classes = useStyles();
  const location = useLocation();
  const {user, initialAuthDone} = useAppInitialization();

  const isCheckingAuth = !initialAuthDone;
  const isAuthenticated = initialAuthDone && !!user;
  const shouldRedirectToLogin = initialAuthDone && !user;

  const pathname = location.pathname;
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div
        id="main-app"
        className={classes.root}
        style={{
          height:
            shouldRedirectToLogin || pathname === '/on-boarding'
              ? '100vh'
              : undefined,
        }}
      >
        <Switch>
          <Route path="/login">
            <UnauthenticatedLayout>
              <AuthContainer />
            </UnauthenticatedLayout>
          </Route>

          <Route path="/on-boarding">
            <UnauthenticatedLayout>
              <Switch>
                <PrivateRoute
                  exact
                  path="/on-boarding"
                  component={OnboardingPage}
                />
                <PrivateRoute
                  path="/on-boarding/trial"
                  component={OnBoardingTrialContainer}
                />
              </Switch>
            </UnauthenticatedLayout>
          </Route>

          <Route>
            {isCheckingAuth && null}
            {isAuthenticated && (
              <AuthenticatedLayout>
                <AppRoutes />
              </AuthenticatedLayout>
            )}
            {shouldRedirectToLogin && (
              <Redirect
                to={{
                  pathname: '/login',
                  state: {referrer: location.pathname},
                }}
              />
            )}
          </Route>
        </Switch>
      </div>
      {user && <BottomNavbarContainer />}
    </ThemeProvider>
  );
}

export default App;
